// 资质/印章使用申请
<template>
  <div class="projectFormLess" v-if="isComponentsShow">
    <!-- 第一行 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
        <span>项目名称</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_project_name}}</span>
      </div>
    </div>
    <!-- 第二行--项目编号 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_bh@2x.png" alt />
        <span>项目编号</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_project_code}}</span>
      </div>
    </div>
    <!-- 第三行--申请原因 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel upLoadLabel" style="padding-top:0">
        <img style="width:16px;margin-top:12px" src="../../assets/image/icon_sqyy@2x.png" alt />
        <span style="margin-top:8px">申请原因</span>
      </div>
      <div class="rightInput rightRadioWithInput">
        <el-radio-group
          :disabled="!isSubmit"
          @change="handleRadioChang"
          v-model="addFormData.reasons_application"
        >
          <el-radio :label="'1'">报告</el-radio>
          <el-radio :label="'2'">合同</el-radio>
          <el-radio :label="'3'">发票</el-radio>
          <el-radio :label="'4'">招投标</el-radio>
          <div>
            <el-radio :label="'-1'">其他</el-radio>
            <el-input
              :disabled="isTypeInputDis || !isSubmit"
              v-model="addFormData.reasons_application_else"
              :placeholder="isSubmit ? '其他原因' : ''"
            ></el-input>
          </div>
        </el-radio-group>
      </div>
    </div>
    <!-- 第四行--印章类别 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:15px" src="../../assets/image/icon_yz@2x.png" alt />
        <span>印章类别</span>
      </div>
      <div class="rightInput">
        <el-radio-group :disabled="!isSubmit" v-model="addFormData.seal_category">
          <el-radio style="width:20%" :label="'1'">公章</el-radio>
          <el-radio style="width:20%" :label="'2'">法人章</el-radio>
          <el-radio style="width:20%" :label="'3'">合同专用章</el-radio>
          <el-radio style="width:20%" :label="'4'">报告专用章</el-radio>
        </el-radio-group>
      </div>
    </div>
    <!-- 第五行--资质类别 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icon_zzzs@2x.png" alt />
        <span>资质类别</span>
      </div>
      <div class="rightInput">
        <el-radio-group :disabled="!isSubmit" v-model="addFormData.qualification_category">
          <el-radio style="width:20%" :label="'1'">煤矿</el-radio>
          <el-radio style="width:20%" :label="'2'">非煤</el-radio>
          <el-radio style="width:20%" :label="'3'">营业执照</el-radio>
        </el-radio-group>
      </div>
    </div>
    <!-- 第六行--用印数量 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_sl@2x.png" alt />
        <span>用印数量</span>
      </div>
      <div class="rightInput">
        <el-input
          :placeholder="isSubmit ? '用印数量' : ''"
          :disabled="!isSubmit"
          v-model="addFormData.quantity_printed"
        ></el-input>
      </div>
    </div>
    <!-- 第七行--合同金额 -->
    <!-- <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icon_jine@2x.png" alt />
        <span>合同金额</span>
      </div>
      <div class="rightInput">
        <el-input placeholder="合同金额" :disabled="!isSubmit" v-model="addFormData.contract_amount"></el-input>
      </div>
    </div>-->
    <!-- 第八行--项目负责人 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
        <span>项目负责人</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_contacts}}</span>
      </div>
    </div>
    <!-- 第九行--经办人 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_jingb@2x.png" alt />
        <span>经办人</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_evaluators}}</span>
      </div>
    </div>
    <!-- 第十行--审批人 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_shenpi@2x.png" alt />
        <span>审批人</span>
      </div>
      <div class="rightInput">
        <!-- approval_member -->
        <span class="isNotSubmitSpan">{{S_member}}</span>
      </div>
    </div>
    <!-- 第十一行--备注： -->
    <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:300px">
        <img style="width:15px" src="../../assets/image/icon_huaf@2x.png" alt />
        <span>备注：</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.remark"
        type="textarea"
        :autosize="{minRows: 3}"
      ></el-input>
    </div>
    <!-- 第十二行--上传附件 -->
    <div class="oneRow">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>上传附件</span>
      </div>
      <div class="rightInput">
        <upload-file
          :isSubmit="isSubmit"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel"></div>
      <div class="rightInput" style="display:flex;align-items:center">
        <div style="color:rgb(245, 95, 95);font-size:12px;">*请上传最终版报告。</div>
      </div>
    </div>

    <!-- 审批备注 -->
    <div class="oneRow" style="margin-bottom:35px;margin-top:20px" v-if="addFormData.is_approve==1">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>审批备注</span>
      </div>
      <div class="rightInput">
        <el-input v-model="approval_remark"></el-input>
      </div>
    </div>

    <!-- 按钮行 -->
    <div class="btnRow">
      <el-button @click="handleSubmit('1')" v-if="addFormData.is_edit!='1'">保存草稿</el-button>
      <el-button
        v-if="addFormData.withdraw_status=='1'"
        @click="handleProjectWithDraw"
        style="background-color:rgb(255, 26, 26);"
      >撤回</el-button>
      <el-button
        style="background-color:#40A0F2"
        @click="handleSubmit('0')"
        v-if="addFormData.is_edit!='1'"
      >提交</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('-1')"
        style="background-color:#f4a029"
      >驳回</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('1')"
        style="background-color:#40A0F2"
      >审批通过</el-button>
    </div>
    <!-- 按钮行 -->

    <!-- 查看进度 -->
    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectFlowLog="this.addFormData.approval_log"
      :companyName="this.addFormData.company_name"
      :projectName="this.addFormData.project_name"
      :projectId="this.addFormData.project_id"
      :stageCode="'44'"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectId="this.addFormData.project_id"
    ></go-finance>
  </div>
</template>
<script>
import ProjectFlow from '../ProjectFlow'
import GoFinance from '../GoFinance'
import UploadFile from '../UploadFile'
export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,

      S_project_name: '',
      S_project_code: '',
      // 项目负责人
      S_contacts: '',
      // 经办人
      S_evaluators: '',
      // 审批人
      S_member: '',

      approval_remark: '',
      isSubmit: true,
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      details_project_id: '',
      details_project_status: '',
      // 文件上传组件
      detailsImgList: [],
      submitImgList: [],
      // 文件上传组件
      addFormData: {
        reasons_application: '1',
        reasons_application_else: '',
        seal_category: '1',
        qualification_category: '1',
        quantity_printed: '',
        contract_amount: '',
        remark: '',
      },
      infop: '',
      isComponentsShow: false,
    }
  },
  methods: {
    // *撤回项目
    async handleProjectWithDraw() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails()
      }, this.timeDou)
    },
    selectPermitChange() {
      if (this.addFormData.permit_type == '1') {
        this.addFormData.permit_type_sub = ''
      }
      if (this.addFormData.permit_type == '2') {
        this.addFormData.permit_type_sub = '1'
      }
    },
    // *审批提交
    async handleExamine(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/seal_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *编辑提交
    async handleSubmit(val) {
      this.addFormData.existing_problems = JSON.stringify(this.tableData)
      if (!this.addFormData.reasons_application_else) {
        this.addFormData.reasons_application_else = ''
      }
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)

        param.append(
          'reasons_application',
          this.addFormData.reasons_application
        )
        param.append(
          'reasons_application_else',
          this.addFormData.reasons_application_else
        )
        param.append('seal_category', this.addFormData.seal_category)
        param.append(
          'qualification_category',
          this.addFormData.qualification_category
        )
        param.append('quantity_printed', this.addFormData.quantity_printed)
        // param.append('contract_amount', this.addFormData.contract_amount)
        param.append('remark', this.addFormData.remark)

        param.append('annex', JSON.stringify(this.submitImgList))

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/seal',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *获取详情
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/seal_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData = res.datas.info
      } else {
        this.addFormData.is_edit = res.datas.info.is_edit
      }
      // 判断禁用
      if (this.addFormData.is_draft != '1' && this.addFormData.is_edit == '1') {
        this.isSubmit = false
      } else {
        this.isSubmit = true
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name
      this.S_project_code = res.datas.info.project_code
      this.S_contacts = res.datas.info.contacts
      res.datas.info.approval_member.forEach((item) => {
        this.S_member += item.nickname + ' '
      })
      this.S_evaluators = res.datas.info.evaluators.nickname
      // this.S_member = res.datas.info.approval_member.nickname

      // 判断文件上传
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      this.isComponentsShow = true
      console.log('资质/印章使用申请', this.addFormData)
    },
    // 文件上传
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    handleRadioChang() {
      if (this.addFormData.reasons_application != '-1') {
        this.addFormData.reasons_application_else = ''
      }
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    if (this.details_project_status && this.details_project_id) {
      this.getProjectDetails()
    }
  },
  computed: {
    isTypeInputDis() {
      if (this.addFormData.reasons_application == '-1') {
        return false
      } else {
        return true
      }
    },
  },
  components: {
    UploadFile,
    ProjectFlow,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(../project/projectForm.less);
</style>